// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: core.proto

/* eslint-disable */

export const protobufPackage = "usertracking.v3";

export interface Core {
  wallet_balance: number;
  number_of_transactions: number;
  charge_amount: number;
  result: string;
  withdrawal_amount: number;
  banner_id: string;
  image_id: string;
  carrier: string;
}

function createBaseCore(): Core {
  return {
    wallet_balance: 0,
    number_of_transactions: 0,
    charge_amount: 0,
    result: "",
    withdrawal_amount: 0,
    banner_id: "",
    image_id: "",
    carrier: "",
  };
}

export const Core: MessageFns<Core> = {
  fromJSON(object: any): Core {
    return {
      wallet_balance: isSet(object.wallet_balance) ? globalThis.Number(object.wallet_balance) : 0,
      number_of_transactions: isSet(object.number_of_transactions)
        ? globalThis.Number(object.number_of_transactions)
        : 0,
      charge_amount: isSet(object.charge_amount) ? globalThis.Number(object.charge_amount) : 0,
      result: isSet(object.result) ? globalThis.String(object.result) : "",
      withdrawal_amount: isSet(object.withdrawal_amount) ? globalThis.Number(object.withdrawal_amount) : 0,
      banner_id: isSet(object.banner_id) ? globalThis.String(object.banner_id) : "",
      image_id: isSet(object.image_id) ? globalThis.String(object.image_id) : "",
      carrier: isSet(object.carrier) ? globalThis.String(object.carrier) : "",
    };
  },

  toJSON(message: Core): unknown {
    const obj: any = {};
    if (message.wallet_balance !== 0) {
      obj.wallet_balance = message.wallet_balance;
    }
    if (message.number_of_transactions !== 0) {
      obj.number_of_transactions = Math.round(message.number_of_transactions);
    }
    if (message.charge_amount !== 0) {
      obj.charge_amount = message.charge_amount;
    }
    if (message.result !== "") {
      obj.result = message.result;
    }
    if (message.withdrawal_amount !== 0) {
      obj.withdrawal_amount = message.withdrawal_amount;
    }
    if (message.banner_id !== "") {
      obj.banner_id = message.banner_id;
    }
    if (message.image_id !== "") {
      obj.image_id = message.image_id;
    }
    if (message.carrier !== "") {
      obj.carrier = message.carrier;
    }
    return obj;
  },

  create(base?: DeepPartial<Core>): Core {
    return Core.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Core>): Core {
    const message = createBaseCore();
    message.wallet_balance = object.wallet_balance ?? 0;
    message.number_of_transactions = object.number_of_transactions ?? 0;
    message.charge_amount = object.charge_amount ?? 0;
    message.result = object.result ?? "";
    message.withdrawal_amount = object.withdrawal_amount ?? 0;
    message.banner_id = object.banner_id ?? "";
    message.image_id = object.image_id ?? "";
    message.carrier = object.carrier ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
